/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IObstetricEvent } from 'app/shared/model/obstetric-event.model';
import { ILaborIncident } from 'app/shared/model/labor-incident.model';
import { IPregnancyCase } from 'app/shared/model/pregnancy-case.model';
import { ISpecialityVitals } from 'app/shared/model/speciality-vitals.model';

export interface ILaborProgression {
  id?: string;
  observation?: string | null;
  comments?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  expose?: boolean | null;
  obstetricEvent?: IObstetricEvent | null;
  incident?: ILaborIncident | null;
  pregnancy?: IPregnancyCase | null;
  vital?: ISpecialityVitals | null;
}

export const defaultValue: Readonly<ILaborProgression> = {
  active: false,
  expose: false,
};
